<template>
  <sp-container flex direction="column" rowgap="0.5rem">
    <sp-label>Drag and Drop Row-component: </sp-label>
    <RowComponent />
  </sp-container>
</template>

<script setup>
import RowComponent from "./RowComponent.ce.vue";
</script>
